import { IOption } from '@utils/interfaces';

export const paymentFormOptions: IOption[] = [
  { value: 'credit_card', label: 'Cartão de crédito' },
  { value: 'billet', label: 'Boleto' },
  { value: 'debit', label: 'Débito em conta' },
];
